import store from '@/store'
import { getData } from '@core/utils/http/general'
import { ref } from '@vue/composition-api'

//* Method to fill param request from table 'Cursos'
export const configTableFactura = () => {
  //* This will be our table columns => { key: 'name of the object propiety', label: 'how to show in table' }
  const tableColumns = [
    {
      key: 'id', label: 'opciónes', sortable: true, isRowHeader: true,
    },
    {
      key: 'alias', sortable: true,
    },
    {
      key: 'razon', sortable: true,
    },
    { key: 'rfc', sortable: true },
    { key: 'calle', sortable: true },
    { key: 'numero', sortable: true },
    { key: 'interior', sortable: true },
    { key: 'colonia', sortable: true },
    { key: 'ref1', sortable: true },
    { key: 'ref2', sortable: true },
    { key: 'cp', sortable: true },
  ]
  //* Params to fill table data & filters
  const configRequest = ref({
    wsParams: { action: 2, token: store.state.cuenta.session.token }, //* Request params
    wsType: 'wsfactura', //* WebService name
    filterGetter: 'cuenta/filterDatosFacturacion',
  })

  return { tableColumns, configRequest }
}

//* Method to fill param request from table 'Materias'
export const configTableMaterias = () => {
  //* This will be our table columns => { key: 'name of the object propiety', label: 'how to show in table' }
  const tableColumns = [
    { key: 'id', sortable: true, stickyColumn: true },
    { key: 'nombre', sortable: true },
    { key: 'objetivo', sortable: true },
    { key: 'opciones' },
  ]
  //* Params to fill table data & filters
  const configRequest = ref({
    wsParams: { action: 1, token: store.state.cuenta.session.token }, //* Request params
    wsType: 'wsmaterias', //* WebService name
    filterGetter: 'servicioEscolar/filterMaterias', //* Getter function to filter data
  })

  return { tableColumns, configRequest }
}

//* Load filter options with promises
export const useServicioEscolarCatalogos = () => {
  const modalidadOptions = [{ label: 'Presencial', value: 'PR' }, { label: 'Sesión remota', value: 'SR' }, { label: 'En línea', value: 'EL' }]
  const periodoOptions = ref([])

  const periodoOptionsPromise = () => new Promise((resolve, reject) => {
    getData({ action: 1, token: store.state.cuenta.session.token }, 'wsperiodo')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) resolve(response.data.data)
        else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })

  return {
    // Promise fetch options
    periodoOptionsPromise,

    // Options
    periodoOptions,
    modalidadOptions,
  }
}
